import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { ContactMembersLinkedComponent } from '../private/CONTACT/contact-members-linked/contact-members-linked.component';
import { GuardConfirmModalComponent } from 'src/app/components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { DialogService } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
})
export class ConfirmLinkedGuard {
  constructor(private dialogService: DialogService) {}

  canDeactivate(component: ContactMembersLinkedComponent) {
    if (!component.editMode) {
      return true;
    }
    return new Observable((observer: Observer<boolean>) => {
      const ref = this.dialogService.open(GuardConfirmModalComponent, {
        header: 'Confirmation',
        styleClass: 'super-compos-modal-content ',
        dismissableMask: false,
        width: '30em',
        data: {
          message: 'Etes-vous sûr de vouloir continuer ?',
        },
      });
      ref.onClose.subscribe({
        next: (value) => {
          if (value) {
            if (value === true) {
              observer.next(true);
              observer.complete();
            } else {
              observer.next(false);
              observer.complete();
            }
          }
        },
      });
    });
  }
}
